import React from 'react';
import { FieldProps, useFieldHelper } from 'framework/ui/field';
import { Box, Typography } from '@mui/material';
import { RISK_STATUS } from 'domain/shared/newProject';
import PriorityHigh from '@mui/icons-material/PriorityHigh';

type RiskStatusFieldProps = FieldProps & {
  statusSource: string;
};

const RiskStatusField = (props: RiskStatusFieldProps) => {
  const { statusSource, isEscalatedSource } = props;
  const { getValue: getStatus } = useFieldHelper<string>({ source: statusSource });
  const { getValue: getIsEscalated } = useFieldHelper<string>({ source: isEscalatedSource });

  const status = getStatus();
  const isEscalated = getIsEscalated();

  return (
    <Box display="flex" flexDirection="row" alignItems="center" gap={0.5}>
      <Typography color={status === RISK_STATUS.ACTIVE ? 'error' : 'textSecondary'}>
        {status === RISK_STATUS.ACTIVE ? 'Active' : 'Inactive'}
      </Typography>
      {isEscalated && <PriorityHigh color="error" />}
    </Box>
  );
};

export default RiskStatusField;
